import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import { getPartsColumns } from './columns';

import { Table } from 'antd';

import Portlet from 'components/layout/Portlet';

const pagination = { position: 'bottom', size: 'small', pageSize: 5 };

const AuctionPartsGrid = ({ parts }) => {
  const columnDefs = React.useMemo(() => {
    return getPartsColumns();
  }, []);

  return (
    <Portlet title={I.t('PARTS')}>
      <Table
        dataSource={parts || []}
        size="small"
        columns={columnDefs}
        pagination={pagination}
        bordered={true}
      />
    </Portlet>
  );
};

export default AuctionPartsGrid;
